import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { API_BASE_URL } from "../../core/base.service";
import type { ShareHomeworkPayload } from "../utils/homework-share";

/** 后端 Create 返回：短 token + 过期时间 */
export interface HomeworkShareCreateResponse {
  token: string;
  /** ISO 日期字符串，前端展示用 */
  expireTime: string;
}

/** 后端 Get 返回：按 status 区分三种状态 */
export type HomeworkShareGetResponse =
  | { status: "ok"; data: ShareHomeworkPayload; expireTime: string }
  | { status: "expired"; expireTime: string }
  | { status: "invalid" };

/**
 * 作业记录分享短链接服务
 *
 * - create：老师对一条作业反馈记录生成分享二维码时，把记录 JSON 存库并拿到短 token（需登录）
 * - get：家长扫码后用 token 取回记录（公开，7 天有效）
 */
@Injectable({ providedIn: "root" })
export class HomeworkShareService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL, { optional: true }) || "";

  /** 生成作业记录分享短链接（需登录），返回 token + 过期时间 */
  create(payload: ShareHomeworkPayload): Observable<HomeworkShareCreateResponse> {
    return this.http.post<HomeworkShareCreateResponse>(
      `${this.apiBaseUrl}/homeworkShare/Create`,
      payload,
    );
  }

  /** 按 token 获取作业分享数据（公开，7 天有效） */
  get(token: string): Observable<HomeworkShareGetResponse> {
    return this.http.get<HomeworkShareGetResponse>(
      `${this.apiBaseUrl}/homeworkShare/Get`,
      { params: { token } },
    );
  }
}
